import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useModalContext } from "../../../../hooks/modalContext";
import { AllMyProjects } from "../../../../dtos/AllMyProjects";
import { useMainHook } from "../../../../hooks/main";
import api from "../../../../services/api";
import { usePagesEditor } from "../../hooks/pagesEditor";
import { useWorkspaceEditor } from "../../hooks/workspaceEditor";
import {
  CanvasContainer,
  FlexEditor,
  SpaceOfContainer
} from "../../screen/styles";
import { NewClausesModal } from "../NewClausesModal";
import { FlexRow, HorizontalStack } from "./styles";
import ButtonAddPageCanva from "../ButtonAddPageCanva";
import CanvasMain from "../Canvas/CanvasMain";
import SceneKonva from "../Canvas/SceneKonva";
import LoadingEditor from "../LoadingEditor";
import TitleOfPage from "./components/TitleOfPage";
import ButtonsPagesControl from "./components/ButtonsPagesControl";
import moreOptionsIcon from "../../assets/more-options-icon.svg";
import IconMoreOptions from "./components/IconMoreOptions";

import ModalVersioning from "../ModalVersioning";
import { useVersioning } from "../../hooks/versioning";
import ModalDescriptionVersioning from "../ModalDescriptionVersioning";
import Konva from "konva";
import { EditClauseModal } from "../EditClauseModal";
import { ModalHex } from "../ModalHex";
import { useSelection } from "../../hooks/selection";
import { useSharedDocument } from "../../hooks/sharedDocument";
import { ModalSharedDocument } from "../ModalSharedDocument";
import { ModalSharedInfo } from "../ModalSharedInfo";
import { useAuth } from "../../../../hooks/auth";
import { ModalActiveUser } from "../ModalActiveUser";
import { useHeaderEditor } from "../../hooks/headerEditor";
import { ModalAcceptDiffs } from "../ModalAcceptDiffs";
import { useDiff } from "../../hooks/diffDocuments";
import { template } from "lodash";
import { ModalBlockFuncionality } from "../ModalBlockFuncionality";
import { toast } from "react-toastify";

interface toggleProps {
  visible?: boolean;
  index: number;
}

interface UsersSharedGroupProps {
  user_template_id?: string;
  users?: [
    {
      id: string;
      name: string;
      email: string;
      avatar_url: string;
      permissions: string;
    }
  ];
}

interface UserProps {
  avatar_url?: string;
  email?: string;
  id?: string;
  name?: string;
  permissions?: string;
}

interface ObjectPermissionProps {
  id: string;
  name: string;
  email: string;
  avatar_url: string;
  permissions: string;
  is_anonymous: boolean;
  current_user: boolean;
}

interface ResponseAccessControlProps {
  access_control: boolean;
  user_list: ObjectPermissionProps[];
}

const EditorMain: React.FC = () => {
  const {
    isNewClausesModalOpen,
    handleCloseNewClausesModal,
    isEditingClause,
    handleCloseEditClauseModal,
    idClause,
    setRefreshClause,
    refreshClause,
    indexClause
  } = useModalContext();

  const { loadingTemplate, setLoadingTemplate } = useWorkspaceEditor();
  const { scaleForZoom } = usePagesEditor();
  const [sizePage, setSizePage] = useState(null);
  const { isOpenEdit, handleCloseModal, typeChangeColor, setTypeChangeColor } =
    useSelection();
  const [alreadyMessageCreated, setAlreadyMessageCreated] = useState(false);

  const {
    isCompareVersionModalOpen,
    setIsCompareVersionModalOpen,
    handleOpenCompareVersionModalOpen,
    handleCloseCompareVersionModalOpen,
    versioningDescriptionModalOpen,
    handleCloseDescriptionVersioningModalOpen,
    forceUpdateRevert
  } = useVersioning();

  const {
    objectScreen,
    setObjectScreen,
    documentName,
    currentTemplateInfo,
    stageRef,
    setLoadThumbnail,
    loadThumbnail,
    setActiveUser,
    templateIsLoaded,
    setTemplateIsLoaded,
    handleCloseModalDiffAccept,
    handleOpenModalDiffAccept,
    isModalDiffAccept,
    nameOfCurrentUser,
    typeModal,
    triggerForEdit,
    setTriggerForEdit,
    loading,
    setLoading,
    isModalBlockFunctionality,
    setIsModalBlockFuncionality,
    handleCloseModalBlockFuncionalities,
    setCreatedSharedDocument,
    createdSharedDocument
  } = useMainHook();

  const { data } = useAuth();
  const navigate = useNavigate();

  const {
    isModalSharedOpen,
    handleCloseModalShared,
    isModalSharedInfoOpen,
    handleCloseModalSharedInfo,
    handleCloseActiveUser,
    handleOpenActiveUser,
    isModalActiveUser,
    setDocumentUsersAccess,
    setIsModalActiveUser,
    documentUsersAccess
  } = useSharedDocument();

  const {
    templateStartedShared,
    setTemplateStartedShared,
    quillReComponent,
    handleDecline
  } = useDiff();

  const { handleAddNewPage, isVisibleAddPage } = usePagesEditor();
  const [permissionDocument, setPermissionDocument] = useState(false);
  const { templateid, typetemplate } = useParams();
  const [loadingDefault, setLoadingDefault] = useState(false);
  const [verifyApi, setVerifyApi] = useState(false);
  const { handleSaveTemplate } = useHeaderEditor();

  const [isOpenOptions, setIsOpenOptions] = useState<toggleProps>({
    visible: true,
    index: 0
  });

  const toggleActiveOptionsPage = (visible?: boolean, index?: any) => {
    setIsOpenOptions({
      visible,
      index
    });
  };

  const [usersSharedGroup, setUsersSharedGroup] =
    useState<UsersSharedGroupProps>({});
  const [usersAuthorized, setUsersAuthorized] = useState<UserProps>({
    avatar_url: null,
    email: null,
    id: null,
    name: null,
    permissions: null
  });

  useEffect(() => {
    const autoLoad = async () => {
      try {
        const responseProfile = await api.get("profile");
        setActiveUser(responseProfile.data.user.id);
      } catch (err) {
        console.log(err, "error when get profile");
      }
    };

    autoLoad();
  }, []);

  // const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  // fetch group of users what can access this template
  useEffect(() => {
    (async () => {
      const belongsSharedGroup = await api.get(
        `user-share-template/all-shared-template-users/${templateid}`
      );
      setUsersSharedGroup(belongsSharedGroup.data);
    })();
  }, []);

  // then verify if this user belongs this group
  useEffect(() => {
    const matchUserInsideGroup = usersSharedGroup?.users?.find(
      user => user.id === data?.user?.id
    );
    //set user as var for security
    setUsersAuthorized(state => {
      let cloneState = { ...state };
      cloneState = matchUserInsideGroup ? matchUserInsideGroup : {};
      return cloneState;
    });
  }, [usersSharedGroup]);

  useEffect(() => {
    if (createdSharedDocument) {
      toast.success(`A cópia foi criada e está salvo em "Meus projetos"`);
      setAlreadyMessageCreated(true);
    }
  }, [createdSharedDocument]);

  useEffect(() => {
    if (alreadyMessageCreated) {
      setCreatedSharedDocument(false);
    }
  }, [alreadyMessageCreated]);

  useEffect(() => {
    (async () => {
      if (usersSharedGroup?.users?.length > 0) {
        if (typetemplate === "my-template" && usersAuthorized.id) {
          try {
            const fetchMyTemplate = await api.get(
              `user-templates/${templateid}`
            );
            const { template } = fetchMyTemplate.data as AllMyProjects;
            currentTemplateInfo.current = fetchMyTemplate.data;
            documentName.current = fetchMyTemplate.data.title;
            setObjectScreen(template.arrayOfPages);
            setLoadingTemplate(false);
            setTemplateIsLoaded(false);
          } catch (error) {
            console.log("Error loading my templatess " + error);
          }
          setLoadThumbnail(true);
        } else {
          navigate("/");
        }
      }
    })();
  }, [usersAuthorized, templateIsLoaded]);

  useEffect(() => {
    const autoLoadUserInsideDocument = async () => {
      try {
        setLoadingDefault(true);
        const responseAccessControlUser = await api.post(
          "user-templates-access-control",
          {
            user_template_id: templateid
          }
        );

        setDocumentUsersAccess(
          responseAccessControlUser.data as ResponseAccessControlProps
        );
        setVerifyApi(true);
        setLoadingDefault(false);
      } catch (err) {
        setLoadingDefault(false);
        console.log(err, "ERROR when post user template access control");
      }
    };

    setTimeout(() => {
      autoLoadUserInsideDocument();
    }, 1000);
  }, []);

  useEffect(() => {
    if (documentUsersAccess) {
      setPermissionDocument(documentUsersAccess.access_control);
    }
  }, [documentUsersAccess]);

  useEffect(() => {
    let interval;

    const autoLoadAccess = async () => {
      try {
        setLoadingDefault(true);
        const responseAccessIntervalUpdate = await api.put(
          "user-templates-access-control",
          {
            user_template_id: templateid
          }
        );
      } catch (err) {
        console.log(err, "ERROR when update user access control");
        setLoadingDefault(false);
      }
    };

    autoLoadAccess();

    if (templateid) {
      interval = setInterval(async () => {
        autoLoadAccess();
      }, 90000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [templateid]);

  useEffect(() => {
    setSizePage(objectScreen.length);
  }, [objectScreen]);

  useEffect(() => {
    if (verifyApi) {
      if (!permissionDocument) {
        setIsModalActiveUser(true);
      }
    }
  }, [verifyApi]);

  //saving template when user open document
  //for generate there thumbnail to the project

  useEffect(() => {
    const autoSaving = async () => {
      try {
        await handleSaveTemplate(true);
      } catch (err) {
        console.log(err, "error when are auto saving... ");
      }
    };

    setTimeout(() => {
      autoSaving();
    }, 2000);
  }, []);

  return (
    <FlexEditor zoomValue={scaleForZoom.scale}>
      <ModalActiveUser
        isOpen={isModalActiveUser}
        // onRequestClose={handleCloseActiveUser}
        dataUsers={documentUsersAccess}
      />

      <NewClausesModal
        isOpen={isNewClausesModalOpen}
        onRequestClose={handleCloseNewClausesModal}
      />

      <ModalHex
        type={typeChangeColor}
        isOpen={isOpenEdit}
        onRequestClose={handleCloseModal}
      />
      <ModalBlockFuncionality
        isOpen={isModalBlockFunctionality}
        onRequestClose={handleCloseModalBlockFuncionalities}
      />
      <ModalSharedDocument
        isOpen={isModalSharedOpen}
        onRequestClose={handleCloseModalShared}
      />

      <ModalSharedInfo
        isOpen={isModalSharedInfoOpen}
        onRequestClose={handleCloseModalSharedInfo}
      />

      <EditClauseModal
        isOpen={isEditingClause}
        onRequestClose={handleCloseEditClauseModal}
        idClause={idClause}
        refreshClause={refreshClause}
        indexClause={indexClause}
        setRefreshClause={setRefreshClause}
      />

      <ModalVersioning
        isOpen={isCompareVersionModalOpen}
        onRequestClose={handleCloseCompareVersionModalOpen}
      />

      <ModalDescriptionVersioning
        isOpen={versioningDescriptionModalOpen}
        onRequestClose={handleCloseDescriptionVersioningModalOpen}
      />
      <CanvasContainer>
        {loadingTemplate ? (
          <div>{/* <LoadingEditor /> */}</div>
        ) : (
          <>
            {objectScreen.map((item, index) => (
              <div key={index.toString()}>
                <HorizontalStack
                  onDragStart={event => {
                    event.preventDefault();
                    return;
                  }}
                >
                  <TitleOfPage index={index} />
                  <FlexRow>
                    {!isOpenOptions.visible && isOpenOptions.index === index ? (
                      <ButtonsPagesControl
                        item={item}
                        index={index}
                        onClick={toggleActiveOptionsPage}
                        pageSize={sizePage}
                      />
                    ) : (
                      <IconMoreOptions
                        onClick={() => toggleActiveOptionsPage(false, index)}
                        imageSrc={moreOptionsIcon}
                      />
                    )}
                  </FlexRow>
                </HorizontalStack>
                <CanvasMain isSecondUser={!permissionDocument}>
                  <SceneKonva
                    isSecondUser={!permissionDocument}
                    item={item}
                    index={index}
                  />
                </CanvasMain>
              </div>
            ))}
          </>
        )}

        {!loadingTemplate ? (
          <ButtonAddPageCanva
            onClick={() => {
              let pages: number[] = [];
              objectScreen.forEach(page => {
                pages.push(page.pageNumber);
              });

              let lengthOfPages = pages.length;

              if (lengthOfPages === 0) {
                handleAddNewPage(1);
              } else {
                handleAddNewPage(lengthOfPages);
              }
            }}
            text="Adicionar Página"
          ></ButtonAddPageCanva>
        ) : (
          <SpaceOfContainer />
        )}
      </CanvasContainer>
    </FlexEditor>
  );
};

export default EditorMain;
